import varAxios from "../../Comman/axios";
import { GetTermsOfUseUrl, updateTermsOfUseUrl,
         UpdateAcceptTermsOfUseUrl, updateTermsOfUseHeaderUrl, updateTermsOfUseSubHeaderUrl } from '../../Comman/apiEndPoints';

export const Fetch_TermsOfUse_Success_Data = "Fetch_TermsOfUse_Success_Data";
export const Update_TermsOfUse_Success = "Update_TermsOfUse_Success";
export const Fetch_Terms_Setting_Request ="Fetch_Terms_Setting_Request";

export function fetchTermsOfUseSuccessData({errorCode,statusCode,termsConditionSetting}) {
   return {
       type: Fetch_TermsOfUse_Success_Data,
       errorCode,
       statusCode,
       termsConditionSetting
   }
}

export function getTermsOfUse() {
   return(dispatch) =>{
      return varAxios.get(GetTermsOfUseUrl)
      .then(response => {
         dispatch(
            fetchTermsOfUseSuccessData({
               errorCode : response.data.errorCode,
               statusCode : response.data.statusCode,
               termsConditionSetting : response.data.GlobalSettings
            }));
      })
      .catch((error) => {
         console.log("error",error);
     })
   }
   
}

export function updateTermsOfUse(value) {
   let data = {
      SettingValue : value
   }
   return (dispatch) => {
      dispatch(fetchTermsSettingRequest())
       return varAxios.post(updateTermsOfUseUrl, data,
           JSON.stringify({
               derived: 'd',
               message: 'e'
           }))
           .then((response) => {
               dispatch(
                   updateTermsOfUseSuccess(response.data.statusCode, response.data.Value)
               );
           })
           .catch((error) => {
               console.log(error)
           })
   }
}

export function updateTermsOfUseSuccess(statuscode,value) {
   return {
      type : Update_TermsOfUse_Success,
      statuscode,
      value
   }
}

export function updateAcceptTermsOfUse(value) {
   let data = {
      SettingValue : value
   }
   return (dispatch) => {
      dispatch(fetchTermsSettingRequest())
       return varAxios.post(UpdateAcceptTermsOfUseUrl, data,
           JSON.stringify({
               derived: 'd',
               message: 'e'
           }))
           .then((response) => {
               dispatch(
                  updateTermsOfUseSuccess(response.data.statusCode, response.data.Value)
            );
           })
           .catch((error) => {
               console.log(error)
           })
   }
}
export function fetchTermsSettingRequest(){
   return{
      type : Fetch_Terms_Setting_Request
   }
}

export function updateTermsOfUseHeader(value) {
   let data = {
      SettingValue : value
   }
   return (dispatch) => {
      dispatch(fetchTermsSettingRequest())
       return varAxios.post(updateTermsOfUseHeaderUrl, data,
           JSON.stringify({
               derived: 'd',
               message: 'e'
           }))
           .then((response) => {
               dispatch(
                  updateTermsOfUseSuccess(response.data.statusCode, response.data.Value)
            );
           })
           .catch((error) => {
               console.log(error)
           })
   }
}

export function updateTermsOfUseSubHeader(value) {
   let data = {
      SettingValue : value
   }
   return (dispatch) => {
      dispatch(fetchTermsSettingRequest())
       return varAxios.post(updateTermsOfUseSubHeaderUrl, data,
           JSON.stringify({
               derived: 'd',
               message: 'e'
           }))
           .then((response) => {
               dispatch(
                  updateTermsOfUseSuccess(response.data.statusCode, response.data.Value)
            );
           })
           .catch((error) => {
               console.log(error)
           })
   }
}